import {
  Button,
  Checkbox,
  FormControlLabel,
  IconButton,
  Tooltip,
} from "@mui/material";
import styled from "styled-components";
import { DeviceType } from "../../utils/hooks/useDeviceHook";
import { Button as SharedButton } from "../shared/Button/Button";
import { TextField } from "../shared/TextField/TextField";
import { StyledButton } from "../shared/Button/Button.styles";

export const UserReportContainer = styled.div`
  margin: 20px;
  max-width: 920px;
`;

export const NavigateBackToDasboard = styled.div`
  display: flex;
  align-items: center;
  grid-gap: 10px;
  color: #f0604b;
  font-size: 24px;
  text-transform: uppercase;
  font-weight: bold;
  margin-bottom: 20px;
`;

export const BackButton = styled(Button)`
  border: 1px solid #f0604b !important;
  border-radius: 30px !important;
  background: ${({ theme }) => theme.redMedium} !important;
  height: 40px;
  width: 50px;
  svg path {
    fill: #fff;
  }
`;

export const BackText = styled.div`
  padding-top: 3px;
  font-family: "bold";
  color: ${({ theme }) => theme.redMedium};
`;

export const GeneralInfoWrapper = styled.div`
  padding: 20px 15px;
  background-color: white;
  margin-bottom: 20px;
`;

export const UserReportBabyPeekWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const UserReportBabyPeekResultsWrapper = styled.div`
  display: grid;
  gap: 10px;
  color: #000;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
`;

export const GeneralInfoProcessing = styled.div`
  display: flex;
  align-items: center;
`;

export const GeneralInfoText = styled.div`
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 12px;
`;

export const GeneralInfoHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 12px;
  padding-right: 10px;

  ${GeneralInfoText} {
    margin-bottom: 0;
  }
`;

export const GeneralInfoCard = styled(GeneralInfoWrapper)`
  padding: 20px;

  ${GeneralInfoHeader} {
    margin-bottom: 24px;
    padding-right: 0;
  }

  ${GeneralInfoText} {
    color: ${({ theme }) => theme.greyMedium};
    font-family: "bold";
    line-height: 28px;
  }
`;

export const IntlBabyPeekModalWrapper = styled.div`
  background: ${({ theme }) => theme.white};
  border-radius: 12px;
  box-shadow: 0 3px 7px rgba(0, 0, 0, 0.3);
  box-sizing: border-box;
  display: grid;
  gap: 20px;
  max-width: calc(100vw - 32px);
  padding: 28px;
  width: 520px;
`;

export const IntlBabyPeekModalTitle = styled.h2`
  color: ${({ theme }) => theme.greyDark};
  font-size: 20px;
  margin: 0;
`;

export const IntlBabyPeekModalDescription = styled.p`
  color: ${({ theme }) => theme.neutral700};
  line-height: 24px;
  margin: 0;
`;

export const IntlBabyPeekModalFields = styled.div`
  display: grid;
  gap: 20px;

  > * {
    width: 100%;
  }
`;

export const IntlBabyPeekModalButtons = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
`;

export const IntlBabyPeekActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`;

export const IntlBabyPeekFeedback = styled.div<{ error?: boolean }>`
  background: ${({ error, theme }) =>
    error ? theme.redPastel : theme.greenPastel};
  color: ${({ error, theme }) => (error ? theme.redDark : theme.greenDark)};
  line-height: 24px;
  padding: 12px;
`;

export const ErrorWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 13px;
  background-color: #fff2f0;
  color: #c0250f;
  font-weight: bold;
  margin-bottom: 15px;
  grid-gap: 10px;
  align-items: center;

  button {
    height: fit-content;
  }
`;

export const ErrorText = styled.div`
  display: flex;
  align-items: center;
  grid-gap: 5px;
`;

export const FieldRow = styled.div`
  display: flex;
  justify-content: space-between;
  grid-gap: 35px;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    grid-gap: 0px;
  }
`;

export const BillingInfoCard = styled(GeneralInfoCard)`
  ${GeneralInfoText} {
    margin-bottom: 24px;
  }
`;

export const BillingFieldRow = styled(FieldRow)`
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 8px;

  && > * {
    flex: 1 1 0;
    min-width: 0;
  }

  @media (max-width: 768px) {
    gap: 8px;

    && > * {
      flex: none;
      width: 100%;
    }
  }
`;

export const EditReport = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-top: 20px;

  button {
    padding: 5px 26px !important;
  }

  @media (max-width: 600px) {
    button {
      width: fit-content !important;
      padding: 4px 24px !important;
    }
  }
`;

export const ResultInfoIconWrapper = styled.div<{ downloadIcon?: boolean }>`
  margin: 2px 0px;
  padding: 2px 0px 5px 0px;
  border-bottom: 1px solid ${({ theme }) => theme.neutral100};
  display: flex;
  align-items: center;
  justify-content: start;
`;

export const ResultInfoIcon = styled.div`
  display: flex;
  align-items: center;
  svg {
    margin: 0px 5px !important;
    cursor: pointer;
  }
`;

export const ResultInfoDownloadWrapper = styled.span`
  display: flex;
  align-items: center;
  cursor: pointer;
  svg {
    margin: 0px 5px 0px 15px !important;
    cursor: pointer;
  }
`;

export const ReportDownloadLink = styled.button`
  align-items: center;
  background: transparent;
  border: 0;
  color: #017e72;
  cursor: pointer;
  display: flex;
  font-family: inherit;
  font-size: 15px;
  gap: 12px;
  line-height: 20px;
  padding: 0;
  text-decoration: underline;

  &:disabled {
    color: ${({ theme }) => theme.neutral500};
    cursor: default;
  }

  svg {
    flex: 0 0 auto;
  }
`;

export const ResultInfoContainer = styled.div`
  padding: 5px 0px;
  width: 50%;
  font-size: 15px;
  @media (max-width: 768px) {
    width: 100%;
    padding: 10px 0;
  }
`;

export const ResultInfoTitle = styled.div`
  color: #5d5a5a;
  display: flex;
  align-items: flex-end;
  grid-gap: 3px;
  font-size: 17px;

  svg {
    width: 16px;
  }
`;

export const GeneralInfoColumns = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;

  @media (max-width: 768px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const GeneralInfoColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;

  > ${ResultInfoContainer} {
    box-sizing: border-box;
    border-bottom: 1px solid ${({ theme }) => theme.neutral100};
    padding: 4px 0 0;
    width: 100%;
    min-height: 56px;
  }

  ${ResultInfoTitle} {
    color: ${({ theme }) => theme.greyLight};
    font-family: "light";
    font-size: 14px;
    line-height: 20px;
  }

  ${ResultInfoIconWrapper} {
    border-bottom: 0;
    margin: 0;
    padding: 0;
  }
`;

export const UserReportPatientReleaseGrid = styled.div`
  display: flex;
  margin-left: 35px;
`;

export const UserReportPatientReleaseStatusIndicator = styled.div<{
  button?: boolean;
}>`
  width: fit-content !important;
  min-width: 160px;
  padding: 0px 10px;
  height: 28px;
  left: 12px;
  top: 19px;
  font-weight: 400;
  font-size: 14px;
  align-items: center;
  display: flex;
  justify-content: center;
  line-height: 20px;
  color: ${({ theme }) => theme.neutral700};
  background: ${({ theme }) => theme.neutral50};
  border: 1px solid ${({ theme }) => theme.neutral100};
  border-radius: 6px;
  cursor: ${({ button }) => (button ? "pointer" : undefined)};
  svg {
    margin-left: 3px;
    width: 20px;
    margin-top: -2px;
  }
`;

export const UserReportPatientReleaseIndicator = styled.div<{
  button?: boolean;
}>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px 12px;
  gap: 8px;
  width: 125px !important;
  height: 26px;
  left: 12px;
  top: 17px;
  background: #f0604b;
  border-radius: 30px;
  color: ${({ theme }) => theme.white};
  background: ${({ theme }) => theme.redMedium};
  cursor: ${({ button }) => (button ? "pointer" : undefined)};

  svg {
    margin-left: 3px;
    width: 20px;
    margin-top: -2px;
  }
`;

export const UserReportStyledSeperator = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  margin-top: 20px;

  ::before,
  ::after {
    content: "";
    flex: 1;
    border-bottom: 1px solid ${({ theme }) => theme.neutral200};
  }

  :not(:empty)::before {
    margin-right: 0.25em;
  }

  :not(:empty)::after {
    margin-left: 0.25em;
  }
`;

export const UserReportGenerateNotesWrapper = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  margin-top: 20px;
  justify-content: center;
  width: 100%;
`;

const getDeviceWidth = (deviceType: DeviceType): string => {
  if (deviceType === "mobile") return "360px";
  if (deviceType === "tablet") return "520px";
  return "672px";
};

export const UserReportGenerateNotesModalWrapper = styled.div<{
  deviceType: DeviceType;
}>`
  display: grid;
  grid-template-rows: 72px auto auto auto;
  height: 800px;
  width: ${({ deviceType }) => getDeviceWidth(deviceType)};
  justify-content: center;
  background: white;
  border-radius: 12px;
  box-shadow: 0 3px 7px rgba(0, 0, 0, 0.3);
  max-height: ${({ deviceType }) =>
    deviceType === "mobile" ? "80%" : undefined};
  overflow: ${({ deviceType }) =>
    deviceType === "mobile" ? "scroll" : undefined};

  .MuiTextField-root {
    position: inherit;
  }

  .MuiInputBase-root {
    margin: 20px 20px;
    padding: 15px 15px 40px 15px;
    box-sizing: border-box;
    background: ${({ theme }) => theme.white};
    border-radius: 12px;
  }

  .Mui-focused {
    color: ${({ theme }) => theme.black} !important;
    background: ${({ theme }) => theme.white};
  }

  .Mui-disabled {
    color: ${({ theme }) => theme.neutral700} !important;
    -webkit-text-fill-color: ${({ theme }) => theme.neutral700} !important;
  }

  textarea {
    overflow: scroll !important;
  }
`;

export const UserReportGenerateNotesModalTextField = styled(TextField)`
  left: 404px;
  top: 331px;
  max-height: 500px;
  overflow: scroll;
`;

export const ProviderLetterModalWrapper = styled.div<{
  deviceType: DeviceType;
}>`
  display: flex;
  flex-direction: column;
  width: ${({ deviceType }) => getDeviceWidth(deviceType)};
  max-width: calc(100vw - 32px);
  max-height: 90vh;
  background: white;
  border-radius: 12px;
  box-shadow: 0 3px 7px rgba(0, 0, 0, 0.3);
  overflow: hidden;
`;

export const ProviderLetterModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 24px;
  overflow: auto;
  color: ${({ theme }) => theme.neutral700};
  font-size: 15px;
  line-height: 20px;

  p {
    margin: 0;
  }
`;

export const ProviderLetterDocument = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 420px;
  padding: 20px;
  border: 1px solid ${({ theme }) => theme.neutral200};
  border-radius: 8px;
  overflow-y: auto;
  font-size: 14px;
  line-height: 21px;

  p {
    margin: 0;
  }
`;

export const ProviderLetterCheckboxes = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ProviderLetterCheckbox = styled(Checkbox).attrs({
  size: "medium",
})`
  && {
    padding: 0 6px 0 0;

    &.Mui-checked {
      color: ${({ theme }) => theme.redMedium};
    }
  }
`;

export const ProviderLetterCheckboxLabel = styled(FormControlLabel)`
  && {
    align-items: center;
    margin: 0;

    .MuiFormControlLabel-label {
      font-size: 15px;
      line-height: 20px;
      padding-top: 4px;
    }
  }
`;

export const ProviderLetterButton = styled(SharedButton).attrs({
  size: "small",
  backgroundColor: "redMedium",
  textColor: "white",
})`
  && {
    min-height: 33px;
  }
`;

export const UserReportGenerateNotesTitle = styled.div<{
  deviceType: DeviceType;
}>`
  display: flex;
  justify-content: space-between;
  height: 72px;
  align-items: center;
  background: ${({ theme }) => theme.neutral100};
  width: ${({ deviceType }) => getDeviceWidth(deviceType)};
  box-sizing: border-box;
  padding-left: 25px;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  border-radius: 12px;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
  svg {
    margin-right: 10px;
    cursor: pointer;
    :hover {
      opacity: 0.7;
    }
  }
`;

export const ProviderLetterCloseButton = styled(IconButton)`
  && {
    margin-right: 8px;
    color: ${({ theme }) => theme.redMedium};

    svg {
      margin-right: 0;
    }

    svg:hover {
      opacity: 1;
    }
  }
`;

export const UserReportGenerateNotesModalGridRow = styled.div<{
  secondaryRow: boolean;
}>`
  display: grid;
  align-items: center;
  grid-template-columns: 50% 50%;
  color: ${({ theme }) => theme.redMedium};
  font-weight: 800;
  border-top: ${({ secondaryRow }) =>
    secondaryRow ? "1px solid #dbdee6" : undefined};
  padding-left: 10px;
`;

export const UserReportGenerateNotesModalText = styled.div<{
  heading: boolean;
  bold?: boolean;
}>`
  display: flex;
  align-items: center;
  text-transform: ${({ heading }) => (heading ? "uppercase" : undefined)};
  color: ${({ theme, heading }) => (heading ? theme.neutral400 : theme.black)};
  font-weight: ${({ bold }) => (bold ? "800" : "400")};
  font-size: ${({ heading }) => (heading ? "14px" : "16px")};
  height: 40px;
`;

export const UserReportGenerateNotesModalNPIMessage = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.greyMedium};
  margin-left: 20px;
`;

export const UserReportGenerateNotesButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 20px 20px;

  gap: 10px;
`;

export const UserReportGenerateNotesButtonsRight = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: auto auto;
  justify-content: end;
  grid-gap: 10px;
  height: 64px;
`;

export const UserReportGenerateNotesPhyscianButtonsRight = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: auto auto;
  justify-content: end;
  grid-gap: 10px;
  height: 64px;

  button {
    padding: 6px 30px !important;
    width: 100%;
  }
`;

export const UserReportGenerateButtonLoader = styled.div`
  width: 130px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const UserReportGenerateNotesDownloadLink = styled.div`
  font-size: 10px;
  text-align: center;
  margin-top: 15px;
  cursor: pointer;
  text-decoration: underline;
  color: ${({ theme }) => theme.blueDark} !important;
`;

export const UserReportGenerateNotesDownloadFile = styled.div`
  font-style: normal;
  font-weight: 500;
  justify-content: center;
  font-size: 14px;
  line-height: 14px;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: 0.01em;
  font-variant: small-caps;
  cursor: pointer;
  padding: 8px 16px;
  font-weight: 700;
  gap: 10px;
  width: 101px;
  right: 16px;
  top: 25%;
  bottom: 25%;
  color: ${({ theme }) => theme.blueDark};
  border: 2px solid ${({ theme }) => theme.blueDark};
  border-radius: 30px;
  margin-right: 30px;

  :hover {
    opacity: 0.8;
  }
`;

export const UserReportGenerateNotesConfirmationsWrapper = styled.div`
  box-sizing: border-box;
  height: 64px;
  left: 19px;
  right: 16px;
  top: 271px;
  background: ${({ theme }) => theme.greenPastel};
  border: 2px solid ${({ theme }) => theme.greenDark};
  border-radius: 6px;
  width: 100%;
  align-items: center;
  display: flex;
  justify-content: left;
  margin-bottom: 15px;
`;

export const UserReportGenerateNotesConfirmationGrid = styled.div`
  display: grid;
  grid-template-columns: 30px auto;
  grid-gap: 15px;
  margin-left: 15px;
  width: 100%;
`;

export const UserReportGenerateNotesConfirmationTextWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

export const UserReportGenerateNotesConfirmationText = styled.div`
  align-items: center;
  display: contents;
  width: 100%;
`;

export const BillingFileUploaderWrapper = styled.div`
  margin-top: 30px;
`;

export const UserReportInternalNotesButtons = styled.div`
  display: grid;
  grid-template-columns: 95px 95px;
  grid-gap: 15px;

  ${StyledButton} {
    width: 95px;
  }
`;

export const UserReportInternalNotesMessage = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.greyMedium};
  margin-bottom: 15px;
`;
